import {Button, Grid} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

const ChangePlanSuccessAction = (props) => {

    const handleCloseDialog = () => {
        props.closeDialog();
        props.handleCloseAddDialog();
    }

    return <Grid container
                 justifyContent="flex-end">
        <Button variant="contained"
                color="primary"
                onClick={handleCloseDialog}>
            Chiudi
        </Button>
    </Grid>
}

ChangePlanSuccessAction.propTypes = {
    closeDialog: PropTypes.func.isRequired
}

export default ChangePlanSuccessAction;